//--------------------------------------------
//
// Scene constants
//
//--------------------------------------------

export default {
	NOTIFICATION_RATE: [2000,7000],
	TIMELINE_RATE: [5000,10000],
	SPARKS_RATE: [5000,15000],

	LATERAL_ARM_SPEED: 0.1,
	VERTICAL_ARM_SPEED: 0.1,

	HEIGHT_RATIO: 1,

	//Initial Arm positioning
	ARM_X: 17.25,
	ARM_Y: 0,
	ARM_Z: 0.1
}

